import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NortonRoutingModule } from './norton-routing.module';
import { NortonDetailsComponent } from './norton-details/norton-details.component';
import { NortonSubscriptionComponent } from './norton-subscription/norton-subscription.component';
import { NortonActivationComponent } from './norton-activation/norton-activation.component';
import { NortonDownloadComponent } from './norton-download/norton-download.component';
import { NortonAntiTheftComponent } from './norton-anti-theft/norton-anti-theft.component';
import { NortonFamilyComponent } from './norton-family/norton-family.component';
import { EffectsModule } from '@ngrx/effects';
import { NortonEffects } from './store/effects/norton.effects';
import { NortonService } from './services/norton.service';
import { PipeModule } from '../pipe/pipe.module';
import {
  AlertModule,
  LoadingSpinnerModule,
} from '@proximus/ng-common-components';
import { AuOnlyGuard } from '../guards/au-only.guard';
import { TranslationModule } from '@proximus/ng-common';
import { Norton360DetailsComponent } from './norton360/norton360-details/norton360-details.component';
import { Norton360SubscriptionComponent } from './norton360/norton360-subscription/norton360-subscription.component';
import { Norton360MyAccountComponent } from './norton360/norton360-my-account/norton360-my-account.component';
import { SharedModule } from '../shared/shared.module';
import { NortonFamilyDownloadComponent } from './norton-family-download/norton-family-download.component';
import { NortonFamilySubscriptionComponent } from './norton-family-subscription/norton-family-subscription.component';

@NgModule({
  declarations: [
    NortonDetailsComponent,
    NortonSubscriptionComponent,
    NortonActivationComponent,
    NortonDownloadComponent,
    NortonAntiTheftComponent,
    NortonFamilyComponent,
    Norton360DetailsComponent,
    Norton360SubscriptionComponent,
    Norton360MyAccountComponent,
    NortonFamilyDownloadComponent,
    NortonFamilySubscriptionComponent
  ],
  imports: [
    CommonModule,
    NortonRoutingModule,
    EffectsModule.forFeature([NortonEffects]),
    TranslationModule,
    PipeModule,
    LoadingSpinnerModule,
    AlertModule,
    SharedModule,
  ],
  providers: [AuOnlyGuard, NortonService],
})
export class NortonModule {}
